import React from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;

import { useClearPackageInit } from '../../hooks/useClearPackageInit';

export const ClearButton = ({ clearState }) => {
  useClearPackageInit(clearState)
  return (<div id="clear-button" />);
};

ClearButton.propTypes = {
  clearState: string.isRequired
}